import React from 'react';

import RankingDetail from './RankingDetail';

const RankingVote = (props: any) => <RankingDetail {...props} view="vote" />;
export default RankingVote;
